import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  inputField: PropTypes.element.isRequired,
  paymentIcon: PropTypes.element.isRequired
};

/** The autoComplete attribute exists within
 * File Input and should be either "cc-number"
 * or "off" for Card Input because only numbers
 * are accepted for a credit card.
 */
function CardInput(_ref) {
  var inputField = _ref.inputField,
    paymentIcon = _ref.paymentIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card-input",
    "data-testid": "card-input"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card-input-field",
    "data-testid": "card-input-field"
  }, inputField), /*#__PURE__*/React__default.createElement("div", {
    className: "card-input-icon",
    "data-testid": "card-input-icon",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, paymentIcon));
}
CardInput.propTypes = propTypes;

export { CardInput as default };
//# sourceMappingURL=CardInput.js.map
